export const enum FilesMigrationStatus {
    relogin = 0,
    authed = 1,
    inProgress = 2,
    success = 3,
    quotaExausted = 4,
    waitTakeout = 5,
    declineTakeout = 6,
    error = 7,
    cancelInProgress = 8,
    canceled = 9,
}

export interface FilesMigrationProfileResponse {
    all_chats_count: number;
    migrated_count: number;
    migrated_files_count: number;
    batches_done_count: number;
    failed_downloads_count: number;
    failed_uploads_count: number;
    current_migration_chat_name: string;
    migration_status: number;
    export_init: number;
    export_start: number;
    migration_current_size: number;
}

export interface FilesMigrationUpdateState {
    allChatsCount: number;
    migratedChatsCount: number;
    status: FilesMigrationStatus;
    migratedBytes: number;
}
